import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import API from "../../api/Createapi";
import './Forgotpasswordpage.css';
import '../login/Loginpage.css'; // Shared auth styles
import { FaEnvelope, FaPaperPlane, FaArrowLeft, FaKey, FaBolt } from 'react-icons/fa';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Loader from '../Loader';
import logo from "../../Assets/ritu broadband.png";

function Forgotpasswordpage() {
    const [email, setEmail] = useState("");
    const [loading, setLoading] = useState(false);
    const [submitted, setSubmitted] = useState(false);
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
            const res = await API.post("/forgot_password.php", { email });

            if (res.data.status === "success") {
                setSubmitted(true);
                toast.success("Password reset link has been sent to your email.");
            } else {
                toast.error("Email address not found in our records.");
            }
        } catch (err) {
            console.error(err);
            toast.error("Server connection error. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="auth-page-wrapper">
            {loading && <Loader />}

            <div className="auth-card forgot-card">
                {/* Hero Side */}
                <div className="auth-hero-banner">
                    <div className="auth-hero-glow auth-glow-1"></div>
                    <div className="auth-hero-glow auth-glow-2"></div>

                    <div className="auth-hero-content">
                        <div className="auth-brand-text-logo">
                            RiTU <span>BROAD BAND</span>
                        </div>

                        <h2 className="auth-hero-title">Account Security</h2>
                        <p className="auth-hero-desc">
                            Don't worry! It happens. We will help you regain access to your account swiftly and securely.
                        </p>

                        <div className="auth-features-list">
                            <div className="auth-feature-item">
                                <div className="auth-feature-icon"><FaKey /></div>
                                <span>Encrypted Password Recovery</span>
                            </div>
                            <div className="auth-feature-item">
                                <div className="auth-feature-icon"><FaBolt /></div>
                                <span>Instant Email Verification</span>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Form Panel Side */}
                <div className="auth-form-panel">
                    <div className="auth-header">
                        <h2>Forgot Password?</h2>
                        <p>Enter your registered email address to receive a password reset link.</p>
                    </div>

                    {!submitted ? (
                        <form onSubmit={handleSubmit} className="auth-form">
                            <div className="input-group">
                                <label htmlFor="email">Registered Email Address</label>
                                <div className="input-field-wrapper">
                                    <span className="input-field-icon"><FaEnvelope /></span>
                                    <input
                                        id="email"
                                        type="email"
                                        placeholder="Enter your registered email"
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                        required
                                    />
                                </div>
                            </div>

                            <button type="submit" className="auth-submit-btn" disabled={loading}>
                                {loading ? "Sending Link..." : <><FaPaperPlane /> Send Reset Link</>}
                            </button>
                        </form>
                    ) : (
                        <div className="auth-success-box">
                            <div className="success-icon-badge">
                                <FaEnvelope />
                            </div>
                            <h3>Check Your Inbox</h3>
                            <p>
                                We've sent a password reset link to <strong>{email}</strong>. Please check your email inbox and follow the instructions.
                            </p>
                            <button
                                className="auth-submit-btn secondary-btn"
                                onClick={() => setSubmitted(false)}
                            >
                                Resend Email Link
                            </button>
                        </div>
                    )}

                    <div className="auth-footer-prompt">
                        <p>
                            Remembered your password?{" "}
                            <span className="auth-action-link" onClick={() => navigate("/login")}>
                                <FaArrowLeft style={{ fontSize: "0.85em", marginRight: "3px" }} /> Back to Sign In
                            </span>
                        </p>
                    </div>
                </div>
            </div>

            <ToastContainer
                position="top-right"
                autoClose={4000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="colored"
            />
        </div>
    );
}

export default Forgotpasswordpage;